var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4305 5.17988C14.6205 5.17988 14.8105 5.24988 14.9605 5.39988L21.0305 11.4699C21.3205 11.7599 21.3205 12.2399 21.0305 12.5299L14.9605 18.5999C14.6705 18.8899 14.1905 18.8899 13.9005 18.5999C13.6105 18.3099 13.6105 17.8299 13.9005 17.5399L19.4405 11.9999L13.9005 6.45988C13.6105 6.16988 13.6105 5.68988 13.9005 5.39988C14.0405 5.24988 14.2405 5.17988 14.4305 5.17988Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.50008 11.25L20.3301 11.25C20.7401 11.25 21.0801 11.59 21.0801 12C21.0801 12.41 20.7401 12.75 20.3301 12.75L3.50008 12.75C3.09008 12.75 2.75008 12.41 2.75008 12C2.75008 11.59 3.09008 11.25 3.50008 11.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.74b6a720fe92c81115e68ac92e10cdd2.svg";
export { ForwardRef as ReactComponent };